<template>
  <div
    v-if="invoice"
    class="check-container"
  >
    <p>
      Please send funds to info@lelandlittle.com and reference invoice #
      {{ invoice.invoice_id }} in the memo.
    </p>

    <div id="amount">Amount {{ customAmount }}</div>

    <div class="wire-transfer-inner">
      <label>Memo:</label>
      <p>
        {{ invoice.customer_display_name }} - Invoice #{{ invoice.invoice_id }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZelleComponent',
  props: ['invoice'],
  data() {
    return {
      customAmount: 0,
    }
  },
  created() {
    if(this.invoice !== undefined){
      this.customAmount = this.invoice.remaing_digital_wallet_amount ? this.invoice.remaing_digital_wallet_amount.toFixed(2) : 0
    }
  },
}
</script>
<style scoped>
#amount {
  font-weight: bold;
  text-align: center;
  font-size: 18px;
}
</style>